import React from "react";
import { branch } from "baobab-react/higher-order";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Flexbox from "flexbox-react";

import MultiSelectToolbar from "./app-multiselect-toolbar";

import { selectAllStatusItems, resetSelectedStatusItems } from "../../actions/statusActions";
import { getOrgId } from "../../actions/orgsActions";
import { isOrganizationAdministrator, isOrganizationEmployeeInternal, isOrganizationUser } from "../../actions/user";

const JAB_CC_ORG_ID = "332a9d47-6e36-11e8-a392-061714f61e3e";

class MultiSelectStatusToolbar extends React.PureComponent {
	render() {
		const isAdmin = isOrganizationAdministrator();
		const isJabCcInternalUser = getOrgId() === JAB_CC_ORG_ID && isOrganizationUser() && isOrganizationEmployeeInternal();
		const canBulkWorkflow = getOrgId() === JAB_CC_ORG_ID && (isAdmin || isJabCcInternalUser);
		const canBulkDelete = isAdmin;
		let multiSelectToolbar =
			<MultiSelectToolbar
				selectedItems={this.props.selectedStatusItems}
				showSelectAll={isAdmin}
				onClickClose={() => {
					this.props.dispatch(
						resetSelectedStatusItems
					);
				}}
				onClickSelectAll={() => {
					this.props.dispatch(
						selectAllStatusItems
					);
				}}>
				<Flexbox flexDirection="row" alignItems="center">
					{canBulkWorkflow &&
						<div style={{ marginRight: "25px", cursor: "pointer" }} onClick={() => {
							window.globalSearchHistoryView.setWorkflowStatuses();
						}}>
							<FontAwesomeIcon icon="users-cog" />
						</div>
					}
					{canBulkDelete &&
						<div style={{ cursor: "pointer" }} onClick={() => {
							window.globalSearchHistoryView.deleteInstances();
						}}>
							<FontAwesomeIcon icon="trash" />
						</div>
					}
				</Flexbox>
			</MultiSelectToolbar>;

		if (this.props.selectedStatusItems.length === 0) {
			multiSelectToolbar = null;
		}

		return multiSelectToolbar;
	}
}

export default branch({
	selectedStatusItems: ["appState", "selectedStatusItems"],
}, MultiSelectStatusToolbar);
